import Logo from "./images/logo.svg"

const Header = () => {
    return (
        <header>
            <img src={Logo} alt="SPLITTER logo" />
        </header>
    )
}

export default Header